export default __webpack_public_path__ + "static/media/element_spec_30.6a316c3e.webp";